module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/152/assets/images/ad51f89999f3d9de409a1848e6a45651.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_action_excel.svg
// module id = gMoa
// module chunks = 1